import { ModelHelper } from '../classes/model-helper';
import { Country } from './country.model';

export class Market {
	countries: Country[];

	/**
	 * Static mapping function
	 *
	 * @param data
	 * @param item
	 * @returns Offering
	 */
	static map(data: any, item: Market = new Market()): Market {
		return item.map(data);
	}

	/**
	 * Non static mapping function
	 *
	 * @param data
	 * @return Offering
	 */
	public map(data: any): any {
		ModelHelper.map(data, this, 'countries', Country);

		return this;
	}
}
